import { useState } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Box,
  Typography,
  Link,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import config from "../../config/config";

export interface OwnFleetApiKeyProps {
  apiKey: string;
}

const OwnFleetApiKey = ({ apiKey }: OwnFleetApiKeyProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopyApiKey = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Hubo un error al copiar: ", error);
    }
  };

  return (
    <Box sx={{ mb: "20px" }}>
      <Typography className="f-s-20">
        Gestión de logística propia y estados de envío
      </Typography>
      <Typography className="f-s-14" sx={{ mt: 1 }}>
        Configura tu flete propio y administra los estados de envío según tus
        necesidades. Podés optar por una actualización manual o automática. Para
        activar la actualización automática, haz{" "}
        <Link
          href={`${config.AUTH_API_BASE_URL}/webhook/api-docs/#/`}
          target="_blank"
        >
          clic aquí.
        </Link>
      </Typography>
      <Typography className="f-s-14 m-b-10" sx={{ mt: 2.5 }}>
        API key
      </Typography>
      <TextField
        size="small"
        sx={{ width: "370px" }}
        value={apiKey}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title={copied ? "¡Copiado!" : "Copiar"}>
                <IconButton onClick={handleCopyApiKey} edge="end">
                  <ContentCopyIcon fontSize="small" sx={{ color: "#C5C7CF" }} />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default OwnFleetApiKey;
